import { ApiBatchContactType, ApiContactType } from '../api-types/contact-type.api';
import { ContactType } from '../app-types/contact-type';

/**
 * Transforms an ApiContactType object to an app-specific ContactType object.
 * @description This function maps properties of the ApiContactType to the ContactType interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiContactType
 * @returns ContactType
 */
export const transformApiContactTypeToAppContactType = (input: ApiContactType) => {
	const output: ContactType = {
		id: input.id,
		jobLink: input.jobLink,
		initial: input.initial,
		remark: input.remark,
	};
	return output;
};

export const transformApiBatchContactTypeToAppContactType = (input: ApiBatchContactType) => {
	const output: ContactType = {
		id: input.contactTypeId,
		initial: input.initial,
		remark: input.remark,
	};
	return output;
};

/**
 * Transforms an array of ApiContactType objects to an array of app-specific
 * ContactType objects.
 * @param input Array of ApiContactType objects
 * @description Transforms an array of ApiContactType objects to an array of app-specific ContactType objects.
 * @returns Array of app-specific ContactType objects
 */
export const transformsApiContactTypesToAppContactTypes = (input: ApiContactType[]) => {
	const output: ContactType[] = input.map(transformApiContactTypeToAppContactType);
	return output;
};

/**
 * Transforms an app-specific ContactType object to an ApiContactType object.
 * @description This function maps properties of the ContactType to the ApiContactType interface.
 * It is used to convert data from the application into a format that can be sent to the API.
 * @param input ContactType
 * @returns ApiContactType
 */
export const transformAppContactTypeToApiContactType = (input: ContactType) => {
	const output: ApiContactType = {
		id: input.id,
		jobLink: input.jobLink,
		initial: input.initial,
		remark: input.remark,
	};
	return output;
};
